export const LOGGER_TOKEN = 'LOGGER';
export interface ILogger {
  debug: (msg: string) => void;
  error: (error: Error) => void;
}
